import PropTypes from 'prop-types';
import React from 'react';
import {
  Modal,
} from 'react-bootstrap';
import BidUpdateForm from './BidUpdateForm';

function formatBidData(jsonObject) {
  // id: bid.id,
  // name: bid.hotel.name,
  // group: bid.bidset.event.group_name,
  // location: `${bid.hotel.locality}, ${bid.hotel.region}`,
  // distance: parseFloat(bid.distance_to_venue * 0.621371).toFixed(1),
  // start: fullDate(bid.bidset.event.start),
  // end: fullDate(bid.bidset.event.end),
  return jsonObject.map(item => ({
    label: `${item.name} (${item.location}) - ${item.group}`,
    value: item.id,
  }));
}
function getInitialValues(jsonObject) {
  // id: bid.id,
  // name: bid.hotel.name,
  // group: bid.bidset.event.group_name,
  // location: `${bid.hotel.locality}, ${bid.hotel.region}`,
  // distance: parseFloat(bid.distance_to_venue * 0.621371).toFixed(1),
  // start: fullDate(bid.bidset.event.start),
  // end: fullDate(bid.bidset.event.end),
  return jsonObject.map(item => (item.id));
}

class BidUpdateModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(values) {
    //const initialValues = this.props.bids;
    //const changedValues = diff(initialValues, values);
    console.log("Send bid update to:", values);
    this.props.sendBidUpdate(values);
    this.props.onClose();
  }
  render() {
    const bidOptions = formatBidData(this.props.bids);
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Send Update to Hotels
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container">
              <div className="row">
                <div className="col-sm-10">
                  <BidUpdateForm
                    initialValues={{ bids: getInitialValues(this.props.bids) }}
                    onSubmit={this.handleSubmit}
                    options={bidOptions}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    );
  }
}


BidUpdateModal.propTypes = {
  bids: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  sendBidUpdate: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

export default BidUpdateModal;



// WEBPACK FOOTER //
// src/routes/tours/components/BidUpdateModal.js